import { render, staticRenderFns } from "./SystemControl.vue?vue&type=template&id=30e3dd33&"
import script from "./SystemControl.vue?vue&type=script&lang=ts&"
export * from "./SystemControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports